class PricePerItem extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    document.addEventListener('test-variant-change', (e) => this.handleVariantChange(e));
  }
  handleVariantChange(event) {
    const selectedVariantId = event.detail || event.target.value;
    if (!selectedVariantId) {
      console.error('Selected variant ID is undefined');
      return;
    }

    const allPrices = this.querySelectorAll('.price-per-item');

    allPrices.forEach(el => {
      const isMatch = el.dataset.variantId == selectedVariantId;
      el.style.display = isMatch ? 'inline' : 'none';
    });
  }
}

customElements.define('price-per-item', PricePerItem);